<template>
  <div :class="spin.id === activeId ? 'active' : ''" class="freeBet__item" @click="onClickSelect(spin.id)">
    <div class="freeBet__item_dot freeBets__dot">
      <div class="dote__wrapper">
        <div class="dote__box">
          <div class="dote__active"></div>
        </div>
      </div>
    </div>
    <div class="freeBets__label_item">{{ spin.reward.betCount }}</div>
    <div class="freeBets__label_item">
      {{ getBetSpin(spin.reward.bet, spin.info.currency.decimals, spin.info.currency.code) }}
    </div>
    <div class="freeBets__label_item">{{ time }}</div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { Utils } from '@/utils/Utils';
import { mapGetters } from 'vuex';
import { IFreeBet, IFreeBetSpin } from '@/store/defaultObjects';

export default Vue.extend({
  name: 'ActiveFreeBet',
  data: () => ({
    time: '',
    timeId: 0
  }),
  props: {
    spin: {
      type: Object as PropType<IFreeBetSpin>,
      required: true
    },
    activeId: {
      type: Number,
      required: true
    }
  },
  mounted() {
    this.setTimeSpin();
    this.timeId = setInterval(this.setTimeSpin.bind(this), 1000);
  },
  computed: {
    ...mapGetters(['getFreeBets']),
    getFromatedCurrency(): string {
      return Utils.formatCurrencyCodeToMili(this.spin.info.currency.code);
    }
  },
  destroyed() {
    clearInterval(this.timeId);
  },
  methods: {
    setTimeSpin(): void {
      this.time = this.getCurrentTime();
    },
    getBetSpin(bet: number, decimals: number, code: string): string {
      return Utils.centsToMoneyStr(bet, decimals, code) + ` ${this.getFromatedCurrency}`;
    },
    getCurrentTime(): string {
      const freeBet: IFreeBet = this.getFreeBets.find(
        (freeBet: IFreeBet) => freeBet.id === (<IFreeBetSpin>this.spin).freeBetId
      );
      if (this.isFreeBetTime(freeBet)) return Utils.getTimeStandardFormat(freeBet.time.finishedAt);
      return Utils.getTimeStandardFormat(this.spin.time.closedAt);
    },
    isFreeBetTime(freeBet: IFreeBet): boolean {
      return this.getDeltaTime(freeBet.time.finishedAt) < this.getDeltaTime(this.spin.time.closedAt);
    },
    getDeltaTime(time: string): number {
      return (new Date(time).getTime() - new Date().getTime()) / 1000;
    },
    onClickSelect(id: number): void {
      this.$emit('onClickSelect', { id });
    }
  }
});
</script>

<style lang="scss" scoped>
.freeBet__item:hover:not(.active) {
  background-color: #000;
}
</style>
